// 솟다 아이콘 — 브랜드 심볼 "날렵 럭셔리 새싹" (골드)
// 2026-06-12 리브랜딩: image-gen 06 시안 원본을 potrace로 픽셀 트레이싱한 path.
// 줄기(e2)·좌잎·우잎 3부위 분리 — 효신님이 브러시 편집기로 연결부를 직접 다듬은 최종본.
//
// 애니메이션은 부모 .sotda-splash 클래스가 styles/splash.css 로 구동한다.
// 부모 클래스가 없으면 정적(최종 상태) 아이콘으로 렌더 — 생장 마스크 기본 r=700이라 전부 보임.

import { useId } from "react";

interface SotdaIconProps {
  /** SVG 한 변 크기(px). 기본 256 */
  size?: number;
}

export function SotdaIcon({ size = 256 }: SotdaIconProps) {
  // 마스크 id는 인스턴스별 유니크 (한 화면에 여러 개 렌더돼도 충돌 X)
  const uid = useId();
  const maskL = `sotda-mask-l-${uid}`;
  const maskR = `sotda-mask-r-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="131 100 1000 1010"
      className="sotda-icon"
      style={{ overflow: "visible" }}
      aria-hidden="true"
    >
      <defs>
        {/* 생장 마스크: 분기점(592,728) 중심 원 — 스플래시에서만 r 0→700 애니, 정적은 700 고정 */}
        <mask id={maskL}>
          <circle className="sotda-grow-l" cx="592" cy="728" r="700" fill="#fff" />
        </mask>
        <mask id={maskR}>
          <circle className="sotda-grow-r" cx="592" cy="728" r="700" fill="#fff" />
        </mask>
      </defs>

      {/* potrace 좌표계: 1254pt + y-flip */}
      <g className="sotda-sway">
        {/* 줄기 — 바닥에서 scaleY로 자람 */}
        <g className="sotda-stem">
          <g transform="translate(0,1254) scale(0.1,-0.1)" fill="var(--sotda-gold)">
            <path d="M5790 5221 c0 -97 -33 -282 -115 -641 -97 -428 -126 -655 -120 -970 5 -294 39 -515 122 -790 60 -198 165 -436 274 -615 48 -81 209 -314 209 -303 0 3 -22 52 -49 109 -186 396 -294 854 -323 1361 -19 343 11 729 92 1151 35 184 143 631 165 684 8 20 15 39 15 44 0 5 -61 9 -135 9 l-135 0 0 -39z" />
          </g>
        </g>
        {/* 좌잎 — 분기점에서 생장 마스크 + 흔들림 */}
        <g className="sotda-leaf-l">
          <g mask={`url(#${maskL})`}>
            <g transform="translate(0,1254) scale(0.1,-0.1)" fill="var(--sotda-gold)">
              <path d="M3270 8530 c272 -168 505 -383 677 -626 117 -164 223 -362 393 -729 35 -77 93 -194 129 -260 201 -376 425 -597 821 -810 240 -129 346 -222 420 -370 62 -124 82 -213 83 -385 1 -157 -9 -242 -55 -480 -44 -223 -46 -211 27 -227 33 -6 76 -12 96 -13 l37 0 6 53 c12 106 31 536 29 673 -5 412 -155 1055 -347 1489 -329 741 -858 1148 -2126 1636 -74 28 -157 59 -185 69 -27 10 -59 21 -70 25 -11 4 18 -16 65 -45z" />
            </g>
          </g>
        </g>
        {/* 우잎 */}
        <g className="sotda-leaf-r">
          <g mask={`url(#${maskR})`}>
            <g transform="translate(0,1254) scale(0.1,-0.1)" fill="var(--sotda-gold)">
              <path d="M9335 10567 c-113 -202 -333 -483 -560 -716 -227 -233 -410 -387 -819 -691 -367 -273 -577 -443 -742 -603 -415 -401 -690 -846 -875 -1416 -102 -314 -173 -647 -283 -1316 -36 -220 -73 -427 -82 -460 -37 -141 -161 -473 -197 -527 -71 -105 -88 -179 -42 -183 11 -1 52 -5 92 -9 64 -7 72 -6 77 11 3 10 28 113 56 228 58 241 131 491 190 649 122 329 246 524 471 741 119 115 213 187 533 410 343 240 556 425 757 660 227 265 386 509 569 875 177 353 289 644 587 1525 74 220 173 505 219 634 46 129 83 236 81 237 -1 2 -16 -20 -32 -49z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
